import type { FC } from "react";

type mobileCloseProps = Record<string, never>;

export const MobileClose: FC<mobileCloseProps> = (_props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18 6.00005L6 18M5.99995 6L17.9999 18"
        stroke="white"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
